import { Flex, Heading, StackProps, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface ListingPageSectionProps extends StackProps {
  id: string;
  title: string;
  dataSource: ReactNode;
}

export const ListingPageSection = ({
  id,
  title,
  children,
  dataSource,
  ...rest
}: ListingPageSectionProps) => (
  <VStack
    alignItems="stretch"
    id={id}
    scrollMarginTop={{ base: '45px', md: '60px' }}
    spacing={4}
    width="100%"
    {...rest}
  >
    <Flex alignItems="center" justifyContent="space-between">
      <Heading size="xs">{title}</Heading>
      {dataSource}
    </Flex>
    {children}
  </VStack>
);
